import React, { useEffect, useState } from 'react'
import { postAPI } from '../../app/api';
import { store, setStore } from '../../app/store';
import ErrorImg from "../../theme/assets/img/illustrations/page-misc-error.png";

export default function Error() {
  return (
    <div class="container-xxl container-p-y text-center">
      <div class="misc-wrapper">
        <h2 class="mb-1 mt-4">Page Not Found :(</h2>
        <p class="mb-4 mx-2">Oops! 😖 The requested URL was not found on this server.</p>
        <a href="index.html" class="btn btn-primary mb-4 waves-effect waves-light">Back to home</a>
        <div class="mt-4">
          <img src={ErrorImg} alt="page-misc-error" width="225" class="img-fluid" />
        </div>
      </div>
    </div>
  )
}
